import { Check, Sparkles, Droplets, Info } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface CheckinInsightCardProps {
  insight: {
    type: "positive" | "hydration" | "movement" | "neutral";
    title: string;
    message: string;
  };
  onReset: () => void;
}

export const CheckinInsightCard = ({ insight, onReset }: CheckinInsightCardProps) => {
  const getIcon = () => {
    switch (insight.type) {
      case "positive": return <Sparkles className="h-8 w-8 text-white" />;
      case "hydration": return <Droplets className="h-8 w-8 text-white" />;
      case "movement": return <Info className="h-8 w-8 text-white" />;
      default: return <Check className="h-8 w-8 text-white" />;
    }
  };

  const getGradient = () => {
    switch (insight.type) {
      case "positive": return "gradient-primary";
      case "hydration": return "bg-gradient-to-br from-blue-400 to-blue-600";
      case "movement": return "bg-gradient-to-br from-amber-400 to-amber-600";
      default: return "gradient-primary";
    }
  };

  return (
    <div className="p-4 md:p-8 max-w-md mx-auto flex flex-col items-center justify-center min-h-[60vh] animate-fade-in">
      <div className={cn("w-16 h-16 rounded-full flex items-center justify-center mb-6 shadow-lg", getGradient())}>
        {getIcon()}
      </div>
      
      <div className="bg-card border shadow-soft rounded-3xl p-6 w-full text-center space-y-3 relative overflow-hidden">
        <h2 className="text-xl font-heading font-bold text-foreground">{insight.title}</h2>
        <p className="text-sm text-muted-foreground leading-relaxed">
          {insight.message}
        </p>
      </div>

      <Button variant="outline" className="mt-8 rounded-xl" onClick={onReset}>
        Hacer otro check-in
      </Button>
    </div>
  );
};
